import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";

// this will reused for single and multiple selection
// we will handle still an array answer but we will transfor to string if not multiple
// currently implemented
// > multiple
export default function WebSelectSVGPath({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [availableChoices, setAvailableChoices] = useState(data.choices);

    const [answer, setAnswer] = useState([]);

    useEffect(() => {
        setAvailableChoices(data.choices);
        setAnswer([]);
    }, [question, data.choices]);

    const handleChoiceClick = async (choice) => {
        let ans = [...answer];
        if (ans.indexOf(choice.value) > -1) {
            removeChoice(choice.value);
        } else {
            ans = [
                ...ans,
                choice.value,
            ];
            
            setAnswer(ans);
            checkCanProceed(ans);
        }
    }

    const checkCanProceed = (ans) => {
        const canProceed = ans.length > 0;
        onAnswer({
            canProceed,
            answer: ans,
        });
    }

    const removeChoice = (value) => {
        let newAnswer = [...answer];
        let index = newAnswer.indexOf(value)
        if (index !== -1) {
            newAnswer.splice(index, 1);
            setAnswer(newAnswer);
        }

        checkCanProceed(newAnswer);
    }

    return (
        <Box
            sx={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                userSelect: "none",
            }}
        >
            <Box
                sx={{
                    position: "relative",
                    marginTop: data.mainDivStyle ?? "0px",
                }}
            >
                <Box component="img" src={`${imagesResources}${data.image}`}/>
                <svg width="100%" 
                    height="100%" 
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                    }}
                >
                    {availableChoices.map((choice, index) => (
                        <React.Fragment key={index}>
                            {typeof choice.path == "string" && (
                                <path
                                style={{ 
                                        textAlign: "center",
                                    }}
                                d={choice.path}
                                fill={answer.includes(choice.value) ? "rgba(255, 217, 102, 0.75)" : "transparent"}
                                stroke={answer.includes(choice.value) ? "#ffc000" : "none"}
                                strokeWidth="3"
                                transform={choice.transform ?? ''}
                                data-value={choice.value}
                                onMouseOver={(event) => {event.target.style.cursor = 'pointer'}}
                                onClick={() => handleChoiceClick(choice)}
                                ></path>
                            )}
                            {Array.isArray(choice.paths) && (
                                <React.Fragment>
                                    {choice.paths.map((path, pathIndex) => (
                                        <path
                                        key={pathIndex}
                                        style={{ 
                                                textAlign: "center",
                                            }}
                                        d={path}
                                        fill={answer.includes(choice.value) ? "rgba(255, 217, 102, 0.75)" : "transparent"}
                                        stroke={answer.includes(choice.value) ? "#ffc000" : "none"}
                                        strokeWidth="3"
                                        data-value={choice.value}
                                        onMouseOver={(event) => {event.target.style.cursor = 'pointer'}}
                                        transform={choice.transform ?? ''}
                                        onClick={() => handleChoiceClick(choice)}
                                        ></path>
                                    ))}
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    ))}
                </svg>
            </Box>
        </Box>
    );
};
